import {
  RequestLangFieldset,
  RequestPaginationFieldset,
  RequestRefFieldset,
  RequestTypeFieldset,
} from "./components"
import { createRequest } from "./createRequest"

export const GetByTypeRequest = createRequest({
  type: "getByType",
  Fieldset() {
    return (
      <>
        <RequestRefFieldset />
        <RequestTypeFieldset />
        <RequestPaginationFieldset />
        <RequestLangFieldset />
      </>
    )
  },
  getSnippet(options) {
    const clientOptions: string[] = []

    if (options.page) {
      clientOptions.push(`  page: ${options.page}`)
    }
    if (options.pageSize) {
      clientOptions.push(`  pageSize: ${options.pageSize}`)
    }
    if (options.lang) {
      clientOptions.push(`  lang: "${options.lang}"`)
    }
    if (options.ref) {
      clientOptions.push(`  ref: "${options.ref}"`)
    }

    return clientOptions.length
      ? `client.getByType(${options["type"] ? `"${options["type"]}"` : "type"}, {\n${clientOptions.join(",\n")}\n})`
      : `client.getByType(${options["type"] ? `"${options["type"]}"` : "type"})`
  },
  run(client, options) {
    return client.getByType(String(options["type"]), {
      page: options.page,
      pageSize: options.pageSize,
      lang: options.lang,
      ref: options.ref,
    })
  },
})
